import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import PropTypes from "prop-types"

class ManageInvestor extends React.Component {

  componentDidMount() {
    const { params: { id }, setCurrentId, reloadInvestor } = this.props
    setCurrentId(id)
    reloadInvestor(id)
  }

  render() {
    const { investor, callback, setInvestor, removeInvestor } = this.props
    return investor
      ? callback(investor, setInvestor, removeInvestor) 
      : <p>Loading ..</p>
  }
}

ManageInvestor.propTypes = {
  investor: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {

  const investor = DckSelectors.selectItemById(
    state,
    ItemTypes.Investor, ownProps.params.id
  )
  return { investor }
},

mapDispatchToProps = dispatch => ({

  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Investor, id)),

  setInvestor: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.Investor, id, data)),

  reloadInvestor: id => dispatch(DckActionCreators.itemReload(ItemTypes.Investor, id)),

  removeInvestor: id => dispatch(DckActionCreators.itemRemove(ItemTypes.Investor, id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageInvestor)



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/ManageItem.js